import { Box } from '@mui/material';
import type { CercharGeneral, CercharStylus } from '../../../types/rockCerchar';
import { StylusEntryTable } from './sections/StylusEntryTable';

interface Props {
  general: CercharGeneral;
  styluses: CercharStylus[];
  onStylusChange: (
    stylusNumber: number,
    field: keyof CercharStylus,
    value: CercharStylus[keyof CercharStylus],
  ) => void;
  readOnly?: boolean;
}

/**
 * Cerchar — Result Entry tab (BUG-2026-0142): the per-specimen stylus entry
 * table and its live auto-calculated results, nothing else. The tab used to be
 * a PLT-style batch grid showing every Cerchar sample in the work order
 * (CercharResultGrid + tabs/search/footer); the lab asked for result entry to
 * be scoped to the specimen that was opened, so the batch machinery was
 * removed. Saving goes through the page-level "Save Test" / footer Save, and
 * remarks stay editable on the Test Parameters tab (same stored field).
 */
export const RockCercharResultEntryTab = ({ general, styluses, onStylusChange, readOnly }: Props) => (
  <Box sx={{ maxWidth: 1180 }}>
    <StylusEntryTable
      general={general}
      styluses={styluses}
      onStylusChange={onStylusChange}
      readOnly={readOnly}
    />
  </Box>
);
